export default "__VITE_ASSET__DR_3nbs8__"